// components/ui/Button.tsx
import React from "react";
import Link from "next/link";
import { ReactNode } from "react";

interface ButtonProps {
  variant?: "primary" | "secondary" | "outline" | "new";
  href?: string;
  size?: "sm";
  children: ReactNode;
  className?: string;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export default function Button({
  variant = "primary",
  href,
  children,
  className = "",
  type = "button",
  disabled = false,
  onClick,
}: ButtonProps) {
  // Base styles shared across variants
  const baseStyles = "px-10 py-2 rounded-lg   transition-colors";

  // Variant-specific styles
  const variantStyles = {
    primary:
      "bg-themeColor text-white hover:bg-opacity-90 focus:ring-[var(--primary-color)]",
    secondary: "bg-white text-black hover:bg-opacity-90 ",
    new: "!w-max !block border !border-themeColor !px-4",
    outline:
      "border border-[var(--primary-color)] text-[var(--primary-color)] hover:bg-[var(--primary-color)] hover:text-white focus:ring-[var(--primary-color)]",
  };

  // Disabled styles
  const disabledStyles = disabled ? "opacity-50 cursor-not-allowed" : "";

  // Combined Tailwind classes
  const combinedClasses = `${baseStyles} ${variantStyles[variant]} ${disabledStyles} ${className}`;

  // Render as Link if href is provided, otherwise as button
  if (href && !disabled) {
    return (
      <Link href={href} className={combinedClasses}>
        {children}
      </Link>
    );
  }

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={combinedClasses}
    >
      {children}
    </button>
  );
}
